import React from 'react';
import {
  Box,
  Chip,
  Tooltip,
  Typography,
  Popover,
  IconButton,
  Divider,
} from '@mui/material';
import {
  Groups as GroupsIcon,
  Info as InfoIcon,
  Category as CategoryIcon,
} from '@mui/icons-material';

const UserTeamInfo = ({ user, availableTeams }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  
  const hasAssignments = (user.teams?.length > 0 || user.teamGroups?.length > 0);

  if (!hasAssignments) {
    return (
      <Typography variant="body2" color="text.secondary">
        No teams or groups assigned
      </Typography>
    );
  }

  const totalTeams = (user.teams?.length || 0) + (user.teamGroups?.length || 0);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Chip
          icon={<GroupsIcon />}
          label={`${totalTeams} ${totalTeams === 1 ? 'assignment' : 'assignments'}`}
          size="small"
          variant="outlined"
          color="primary"
        />
        <Tooltip title="View Assignments">
          <IconButton size="small" onClick={handleClick}>
            <InfoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2, maxWidth: 300 }}>
          {user.teams?.length > 0 && (
            <>
              <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                <GroupsIcon fontSize="small" />
                Direct Team Assignments
              </Typography>
              {user.teams.map((team) => (
                <Box
                  key={team.id}
                  sx={{
                    mb: 1,
                    p: 1,
                    borderRadius: 1,
                    bgcolor: 'background.paper',
                    border: '1px solid',
                    borderColor: 'divider',
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {team.name}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      mt: 0.5,
                    }}
                  >
                    <Chip
                      label={`Role: ${team.role}`}
                      size="small"
                      variant="outlined"
                    />
                    <Chip
                      label={`${team.schoolCount || 0} schools`}
                      size="small"
                      variant="outlined"
                    />
                  </Box>
                </Box>
              ))}
            </>
          )}

          {user.teams?.length > 0 && user.teamGroups?.length > 0 && (
            <Divider sx={{ my: 2 }} />
          )}

          {user.teamGroups?.length > 0 && (
            <>
              <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                <CategoryIcon fontSize="small" />
                Team Group Assignments
              </Typography>
              {user.teamGroups.map((group) => (
                <Box
                  key={group.id}
                  sx={{
                    mb: 1,
                    p: 1,
                    borderRadius: 1,
                    bgcolor: 'background.paper',
                    border: '1px solid',
                    borderColor: 'divider',
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {group.name}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      mt: 0.5,
                    }}
                  >
                    <Chip
                      label={`Role: ${group.role}`}
                      size="small"
                      variant="outlined"
                    />
                    <Chip
                      label={`${group.teamCount || 0} teams`}
                      size="small"
                      variant="outlined"
                    />
                  </Box>
                </Box>
              ))}
            </>
          )}
        </Box>
      </Popover>
    </Box>
  );
};

export default UserTeamInfo;